<template>
  <b-modal
    :active="true"
    aria-role="dialog"
    aria-modal
    trap-focus
    scroll="keep"
    full-screen
    class="dij-modal-dynamic-width"
  >
    <b-loading :is-full-page="true" :active="isLoading" :can-cancel="false">
    </b-loading>
    <ocr-modal
      :active="activeOCR"
      @close="() => (activeOCR = false)"
      :tool="tool"
      @newRatRows="addRATData"
      :file="ocrFile"
      :isMinor="activeTab === 1"
    />

    <DocumentsModal
      v-if="isDocumentModalVisible"
      :isDocumentModalVisible="isDocumentModalVisible"
      @close="closeDocumentModal"
      :selectMode="true"
      @selectFile="onSelectDocumentModal"
    />

    <b-modal
      v-if="isCameraVisible"
      :active="true"
      class="dij-ra-camera-modal"
      full-screen
    >
      <camera @cancel="hideCamera" @ok="processCamera" />
    </b-modal>
    <div class="modal-card">
      <header class="modal-card-head">
        <div>
          {{ $t('repair_assessment') }}
        </div>
        <div class="dij-ra-status">
          <b-button
            :loading="waitingForRead"
            icon-left="refresh"
            @click="refresh"
          ></b-button>
          <b-button
            class="dij-ra-save-status"
            :loading="waitingForWrite"
            :type="waitingForWrite ? 'is-warning' : 'is-success'"
            :icon-left="waitingForWrite ? '' : 'check-circle'"
            >{{ $t('saved') }}</b-button
          >
        </div>
      </header>
      <div class="dij-ra-header">
        <div class="dij-ra-action-header">
          <b-tooltip
            :label="isPreAssemblyOk ? $t('rat_audit_ok') : $t('rat_audit_fail')"
            type="is-light"
            position="is-right"
          >
            <b-button
              icon-left="seal"
              :type="isPreAssemblyOk ? 'is-success' : 'is-danger'"
              >{{ $t('pre_assembly_audit') }}</b-button
            >
          </b-tooltip>
          <b-button
            icon-left="download"
            :type="'is-success'"
            @click="exportRepairAssessment"
            >{{ $t('donwload_rat') }}</b-button
          >
          <b-button
            icon-left="upload"
            :disabled="readOnly"
            @click="$refs.importAdd.click()"
            >{{ $t('upload_rat') }}</b-button
          >

          <OcrFileSelect
            @onFileChange="onFileChangeOCR"
            @onDocumentsModal="showDocumentsModal"
            @showCamera="showCamera"
            :disabled="readOnly"
          />

          <input
            ref="importAdd"
            type="file"
            class="hidden"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            @change="handleRepairAssessmentImportAdd"
          />
        </div>

        <b-notification v-if="showUploadProgress" :closable="false">
          {{ $t('common.uploading_progress', { uploaded, total }) }}
        </b-notification>
        <b-input
          icon="magnify"
          :placeholder="$t('search')"
          @input="searchRepairAssessment"
        />
      </div>
      <section class="modal-card-body">
        <div class="flex-container">
          <b-tabs type="is-boxed" :expanded="false" v-model="activeTab">
            <b-tab-item
              :label="$t('shared.major_components')"
              icon="engine"
              class="b-tab-item-scroll"
            >
              <repair-assessment-detail
                ref="repairAssessment"
                v-model="filteredMajorRepairAssessment"
                :read-only="readOnly"
                :tool="tool"
                @input="onInput"
              />
            </b-tab-item>
            <b-tab-item
              :label="$t('shared.minor_components')"
              icon="screw-flat-top"
              class="b-tab-item-scroll"
            >
              <repair-assessment-detail
                ref="repairAssessmentMinor"
                v-model="filteredMinorRepairAssessment"
                :read-only="readOnly"
                :tool="tool"
                :isMinorComponents="true"
                @input="onInput"
              />
            </b-tab-item>
          </b-tabs>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="dij-ra-left-actions">
          <b-button
            type="is-primary"
            icon-right="plus"
            :disabled="readOnly"
            @click="addRow"
          />
        </div>
        <div class="dij-ra-rigth-actions">
          <b-button @click="close">
            {{ $t('close') }}
          </b-button>
        </div>
      </footer>
    </div>
  </b-modal>
</template>
<script>
import { v4 } from 'uuid';
import RepairAssessmentDetail from './RepairAssessmentDetail';
import RepairAssessmentMixin from '../../mixins/RepairAssessmentMixin';
import OcrFileSelect from './OcrFileSelect';
import OcrModal from './OcrModal';
import DocumentsModal from '../Shared/DocumentsModal';
import Camera from './Camera';
import { GET_CURRENT_JOB } from '../../store/jobs/getters/getterTypes';
import {
  WEBSOCKET_EVENT_SUBSCRIBE_TO_ACTION,
  WEBSOCKET_EVENT_UNSUBSCRIBE_FROM_ACTION,
} from '../../store/websocket/actions/actionTypes';

const uuidv4 = v4;

export default {
  name: 'repair-assessment-detail-dialog',
  props: ['readOnly', 'tool'],
  emits: ['close'],
  mixins: [RepairAssessmentMixin],
  data() {
    return {
      repairAssessment: [],
      filteredRepairAssessment: [],
      searchText: '',
      showUploadProgress: false,
      uploaded: 0,
      total: 0,
      activeTab: 0,
      activeOCR: false,
      ocrFile: null,
      isDocumentModalVisible: false,
      isCameraVisible: false,
      isLoading: false,
    };
  },
  components: {
    RepairAssessmentDetail,
    OcrModal,
    OcrFileSelect,
    DocumentsModal,
    Camera,
  },
  computed: {
    job() {
      return this.$store.getters[GET_CURRENT_JOB];
    },
    jobs() {
      return this.$store.state.jobs;
    },
    waitingForRead() {
      return this.$store.state.waitingForRead;
    },
    waitingForWrite() {
      return this.$store.state.waitingForWrite;
    },
    filteredMinorRepairAssessment() {
      return this.job.repairAssessment.filter((row) => row.isMinor);
    },
    filteredMajorRepairAssessment() {
      return this.job.repairAssessment.filter((row) => !row.isMinor);
    },
    isPreAssemblyOk() {
      return this.filteredMajorRepairAssessment.every(
        (element) => this.isQualityControlGreen(element) && element.reviewed
      );
    },
  },
  async created() {
    const { id } = this.$route.params;
    this.isLoading = true;
    try {
      await this.$store.dispatch('getJob', id);
      this.filterRepairAssessments();
    } finally {
      this.isLoading = false;
      this.$store.commit('SET_PROGRESS_BAR', {
        key: 'repair-assessment',
        value: null,
        message: '',
      });
    }

    const wsMappings = {
      ratRowCreated: this.refresh,
      ratRowDeleted: this.refresh,
      ratRowUpdated: this.refresh,
    };

    Object.keys(wsMappings).forEach(async (key) => {
      await this.$store.dispatch(WEBSOCKET_EVENT_SUBSCRIBE_TO_ACTION, {
        action: key,
        callback: wsMappings[key],
      });
    });
  },
  beforeDestroy() {
    const wsMappings = {
      ratRowCreated: this.refresh,
      ratRowDeleted: this.refresh,
      ratRowUpdated: this.refresh,
    };

    Object.keys(wsMappings).forEach(async (key) => {
      await this.$store.dispatch(WEBSOCKET_EVENT_UNSUBSCRIBE_FROM_ACTION, {
        action: key,
        callback: wsMappings[key],
      });
    });
  },
  watch: {
    'job.repairAssessment': {
      handler(newRepairAssessment) {
        const tempRAT = newRepairAssessment.map((element) =>
          element.id ? { ...element } : { id: uuidv4(), ...element }
        );
        this.filteredRepairAssessment = [...tempRAT];
      },
      immediate: true,
    },
  },

  methods: {
    filterRepairAssessments() {
      this.repairAssessment = [];
      if (this.job.repairAssessment) {
        this.job.repairAssessment.forEach((element) => {
          if (element.id) {
            this.repairAssessment.push({ ...element });
          } else {
            this.repairAssessment.push({ id: uuidv4(), ...element });
          }
        });
        this.filteredRepairAssessment = [...this.repairAssessment];
      }
    },
    onFileChangeOCR(file) {
      this.ocrFile = file;
      this.activeOCR = true;
    },

    onInput(value) {
      this.repairAssessment = [...this.repairAssessment, value];
    },
    close() {
      if (!this.readOnly) {
        if (!this.waitingForWrite) {
          this.$store
            .dispatch('unlockRepairAssessment', {
              job: this.job,
              tool: this.tool,
            })
            .then((repairAssessment) => {
              this.job.repairAssessment = repairAssessment;
            });
        }

        this.job.repairAssessment = this.repairAssessment;
      }
      this.$emit('close');
    },

    searchRepairAssessment(text) {
      if (text) {
        const lowerCaseText = text.toLowerCase();
        this.filteredRepairAssessment = this.repairAssessment.filter(
          (element) => {
            return (
              (element.assembly &&
                element.assembly
                  .toString()
                  .toLowerCase()
                  .includes(lowerCaseText)) ||
              (element.itemNumber &&
                element.itemNumber
                  .toString()
                  .toLowerCase()
                  .includes(lowerCaseText)) ||
              (element.partName &&
                element.partName
                  .toString()
                  .toLowerCase()
                  .includes(lowerCaseText)) ||
              (element.partNumber &&
                element.partNumber
                  .toString()
                  .toLowerCase()
                  .includes(lowerCaseText))
            );
          }
        );
      } else {
        this.filteredRepairAssessment = this.repairAssessment;
      }
    },

    async addRow() {
      if (this.activeTab === 0) {
        this.$refs.repairAssessment.addRow({ isMinor: false });
      }

      if (this.activeTab === 1) {
        this.$refs.repairAssessmentMinor.addRow({ isMinor: true });
      }
    },

    async refresh() {
      const repairAssessment = await this.$store.dispatch(
        'getRepairAssessment',
        this.job
      );

      this.repairAssessment = [...repairAssessment];
      this.filteredRepairAssessment = [...repairAssessment];
    },

    isQualityControlGreen(item) {
      if (this.$refs.repairAssessment) {
        return (
          this.$refs.repairAssessment.getQualityControlType(item) ===
            'is-success' ||
          this.$refs.repairAssessment.getQualityControlType(item) ===
            'is-warning'
        );
      }

      return false;

      // return (
      //   (this.$refs.repairAssessment &&
      //     this.$refs.repairAssessment.getQualityControlType(item) ===
      //       'is-success') ||
      //   this.$refs.repairAssessment.getQualityControlType(item) === 'is-warning'
      // );
    },

    async onSelectDocumentModal({ url: fileUrl, fileName, fileType }) {
      try {
        this.isLoading = true;
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        const file = new File([blob], fileName, { type: fileType });
        this.ocrFile = file;
        this.activeOCR = true;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    startOCR() {
      this.activeOCR = true;
    },
    async addRATData(rows) {
      try {
        this.isLoading = true;
        await this.$refs.repairAssessment.addRATData(rows);
        await this.refresh();
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    showDocumentsModal() {
      this.isDocumentModalVisible = true;
    },
    closeDocumentModal() {
      this.isDocumentModalVisible = false;
    },
    showCamera() {
      this.isCameraVisible = true;
    },

    hideCamera() {
      this.isCameraVisible = false;
    },

    processCamera(canvas) {
      this.hideCamera();
      const base64String = canvas.toDataURL();
      const byteCharacters = atob(base64String.split(',')[1]);
      const byteArrays = [];
      const fileType = 'image/png';
      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      const blob = new Blob(byteArrays, { type: fileType });
      const file = new File([blob], 'image', { type: fileType });
      this.ocrFile = file;
      this.activeOCR = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.dij-ra-action-header {
  display: flex;
  gap: 10px;
}

.tab-content {
  height: 100% !important;
}
.b-tab-item-scroll {
  height: 100%;
}
.flex-container {
  display: flex;
  height: 100%;
  width: 100%;
}

::v-deep div.animation-content.modal-content {
  display: flex;
  flex-direction: column;
}
// Set max width and correct font-size
div.dij-modal-dynamic-width {
  font-size: 16px;
}
// Set max heigth
section.modal-card-body {
  flex: 1 0 0;
  padding: 0px;
}
.dij-ra-rigth-actions {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
// hide modal close button
::v-deep button.modal-close.is-large {
  display: none;
}
.dij-ra-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  background-color: white;
  padding: 10px;

  & > div.control {
    width: 250px;
  }
}

// Make padding smaller for header and footer
.modal-card-head,
.modal-card-foot {
  padding: 10px;
}

.modal-card-head {
  display: flex;
  justify-content: space-between;
}
.dij-ra-status {
  display: flex;
  gap: 10px;

  .dij-ra-save-status {
    border-radius: 0;
    cursor: unset;
    background: white;
    color: green;
  }
}
</style>

<style scoped>
.b-tabs {
  width: 100%;
}
.tab-content {
  height: calc(100% - 43px);
  padding: 0px;
}
</style>
